/**
 * CocktailBox — Home Best Sellers Slider (Flickity)
 */

(function () {
  'use strict';

  var FLICKITY_JS = (window.cbAssets && window.cbAssets.flickity) || 'https://cdnjs.cloudflare.com/ajax/libs/flickity/2.3.0/flickity.pkgd.min.js';
  var SLIDER_SEL = '.cb-bestsellers__slider';

  // -------------------------------------------------------------------------
  // Helpers
  // -------------------------------------------------------------------------

  function loadScript(src, cb) {
    if (typeof Flickity !== 'undefined') { cb(); return; }
    var existing = document.querySelector('script[src="' + src + '"]');
    if (existing) { existing.addEventListener('load', cb); return; }
    var s = document.createElement('script');
    s.src = src;
    s.onload = cb;
    s.onerror = function () { console.warn('Failed to load Flickity'); };
    document.head.appendChild(s);
  }

  // -------------------------------------------------------------------------
  // Slider
  // -------------------------------------------------------------------------

  function initSlider() {
    var slider = document.querySelector(SLIDER_SEL);
    if (!slider || slider.classList.contains('flickity-enabled')) return;

    var flkty = new Flickity(slider, {
      cellAlign: 'left',
      contain: true,
      pageDots: false,
      prevNextButtons: false,
      freeScroll: false,
      wrapAround: false,
      percentPosition: true,
      accessibility: true,
      dragThreshold: 15
    });

    buildDots(flkty);
    bindArrows(flkty);
    updateArrows(flkty);
    syncTabOrder(flkty);

    flkty.on('select', function () {
      highlightDot(flkty);
      updateArrows(flkty);
      syncTabOrder(flkty);
    });

    slider._flickity = flkty;
  }

  // Flickity sets aria-hidden on cells outside the viewport; the card links
  // inside them must leave the tab order too (axe: aria-hidden-focus).
  function syncTabOrder(flkty) {
    flkty.cells.forEach(function (cell) {
      var el = cell.element;
      var hidden = el.getAttribute('aria-hidden') === 'true';
      var links = el.matches('a, button') ? [el] : [];
      links = links.concat(Array.prototype.slice.call(el.querySelectorAll('a, button')));
      links.forEach(function (link) {
        if (hidden) link.setAttribute('tabindex', '-1');
        else link.removeAttribute('tabindex');
      });
    });
  }

  // -------------------------------------------------------------------------
  // Dots
  // -------------------------------------------------------------------------

  function buildDots(flkty) {
    var container = document.querySelector('.cb-bestsellers__dots');
    if (!container) return;
    container.innerHTML = '';

    flkty.cells.forEach(function (_, i) {
      var dot = document.createElement('button');
      dot.className = 'cb-bestsellers__dot' + (i === 0 ? ' is-selected' : '');
      dot.setAttribute('aria-label', (container.getAttribute('data-slide-label') || 'Слайд') + ' ' + (i + 1));
      if (i === 0) dot.setAttribute('aria-current', 'true');
      dot.addEventListener('click', function () { flkty.select(i); });
      container.appendChild(dot);
    });
  }

  function highlightDot(flkty) {
    var container = document.querySelector('.cb-bestsellers__dots');
    if (!container) return;
    var dots = container.querySelectorAll('.cb-bestsellers__dot');
    dots.forEach(function (dot, i) {
      dot.classList.toggle('is-selected', i === flkty.selectedIndex);
      if (i === flkty.selectedIndex) dot.setAttribute('aria-current', 'true');
      else dot.removeAttribute('aria-current');
    });
  }

  // -------------------------------------------------------------------------
  // Arrows
  // -------------------------------------------------------------------------

  function bindArrows(flkty) {
    var prev = document.querySelector('.cb-bestsellers__nav-btn--prev');
    var next = document.querySelector('.cb-bestsellers__nav-btn--next');

    if (prev && !prev._bound) {
      prev._bound = true;
      prev.addEventListener('click', function () { flkty.previous(); });
    }
    if (next && !next._bound) {
      next._bound = true;
      next.addEventListener('click', function () { flkty.next(); });
    }
  }

  function updateArrows(flkty) {
    var prev = document.querySelector('.cb-bestsellers__nav-btn--prev');
    var next = document.querySelector('.cb-bestsellers__nav-btn--next');
    if (prev) prev.disabled = flkty.selectedIndex === 0;
    if (next) next.disabled = flkty.selectedIndex >= flkty.cells.length - 1;
  }

  // -------------------------------------------------------------------------
  // Images: fetched one viewport ahead, so they never compete with the first
  // screen (the product-page hero is the LCP). Independent of window.cbLater.
  // -------------------------------------------------------------------------

  function hydrateImages(root) {
    var scope = root || document;
    var sections = scope.querySelectorAll('.cb-bestsellers');
    if (!sections.length) return;
    var swapAll = function (section) {
      Array.prototype.forEach.call(section.querySelectorAll('.cb-bestsellers__image[data-src]'), function (img) {
        var src = img.getAttribute('data-src');
        img.removeAttribute('data-src');
        if (src) img.src = src;
      });
    };
    if (!('IntersectionObserver' in window)) {
      Array.prototype.forEach.call(sections, swapAll);
      return;
    }
    // The whole slider at once (cells off to the right never intersect on their own)
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        io.unobserve(entry.target);
        swapAll(entry.target);
      });
    }, { rootMargin: '100% 0px' });
    Array.prototype.forEach.call(sections, function (section) { io.observe(section); });
  }

  // -------------------------------------------------------------------------
  // Boot
  // -------------------------------------------------------------------------

  function boot() {
    if (typeof Flickity !== 'undefined') {
      initSlider();
    } else {
      loadScript(FLICKITY_JS, initSlider);
    }
  }

  // The slider sits below the fold: Flickity loads with the other non-critical
  // scripts (window.cbLater, layout/theme.liquid)
  function start() {
    hydrateImages();
    if (window.cbLater) window.cbLater(boot); else boot();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }

  document.addEventListener('shopify:section:load', function (e) {
    if (e.target.querySelector(SLIDER_SEL)) { hydrateImages(e.target); boot(); }
  });
})();
